import { IHousingObjectResponse, ImageWithSizes, MediaFile } from '@/types';
import { DOWNLOADABLE_MEDIA_KEYS, TOUR_DOMAINS } from './constants';

export function buildImageListWithFallback(
  data: IHousingObjectResponse,
): ImageWithSizes[] | undefined {
  if (data.imageList && data.imageList.length > 0) {
    return data.imageList;
  }
  if (data.media?.image && data.media.image.length > 0) {
    return data.media.image.flatMap((img) => {
      const fullUrl = img.link;
      if (!fullUrl) return [];
      const midUrl = fullUrl.replace(/\.([^.]+)$/, '_mid.$1');
      const tmbUrl = fullUrl.replace(/\.([^.]+)$/, '_tmb.$1');
      return { imageFullUrl: fullUrl, imageMidUrl: midUrl, imageTmbUrl: tmbUrl };
    });
  }
  return undefined;
}

export function is3DTour(link?: string): boolean {
  const l = link?.toLowerCase() ?? '';
  return TOUR_DOMAINS.some((domain) => l.includes(domain.toLowerCase()));
}

export function getDownloadableFiles(media: IHousingObjectResponse['media']): MediaFile[] {
  const result: MediaFile[] = [];

  if (!media) return result;

  Object.entries(media).forEach(([key, files]) => {
    if (DOWNLOADABLE_MEDIA_KEYS.includes(key)) {
      result.push(...files);
    }
  });

  return result;
}
